import { render } from "./CaretDown.svg?vue&type=template&id=80115d2c"
const script = {}
script.render = render

export default script